import {
  selectAllPropPresets,
  selectSelectedTake3D,
  selectSelectedTakeProps,
} from "../../../app/slices/TrainingSlice";
import { useSelector } from "react-redux";
import { PiInteractionDropdown } from "../../../components/PiInteractionDropdown";
import ActorAvatar from "../../../components/actors/ActorAvatar";
import React, { useMemo } from "react";
import {
  selectPropById,
  selectProps,
  selectUsedProps,
} from "../../../app/slices/PropLibrarySlice";
import { RootState } from "../../../app/Store";
import { PropTakeState } from "../../../models/PropTakeState";
import usePropHelper from "../../../hooks/PropHelper";
import { useResolvedPath } from "react-router-dom";
import { GetNewGuid } from "../../../helpers/GuidHelper";

export default function PropDropdown(props: {
  label: string;
  selectedPropStateId: string;
  onClick: (propStateId: string) => void;
  includeAttachedProps?: boolean;
}) {
  const {
    label,
    selectedPropStateId,
    onClick,
    includeAttachedProps = false,
  } = { ...props };
  const { getIsPropAttachedToActor } = usePropHelper();
  const take = useSelector(selectSelectedTake3D);
  const propsInTake = take!.props;
  const attachments = take!.attachments;

  const propsInTakeNotGrabbed = useMemo(() => {
    const result: PropTakeState[] = [];

    propsInTake.forEach((pit) => {
      if (!getIsPropAttachedToActor(pit)) result.push(pit);
    });
    if (includeAttachedProps) {
      Object.entries(attachments).forEach(([propId, attachment]) => {
        result.push({
          id: GetNewGuid(),
          instanceId: propId,
          positionId: attachment.id,
        });
      });
    }
    return result;
  }, [propsInTake]);

  const allProps = useSelector(selectProps);
  const allPropPresets = useSelector(selectAllPropPresets);

  const selectedPropState = useMemo(() => {
    var result = propsInTake.find(
      (propState) => propState.instanceId === selectedPropStateId
    );
    if (!result && attachments[selectedPropStateId]) {
      result = {
        id: GetNewGuid(),
        instanceId: selectedPropStateId,
        positionId: attachments[selectedPropStateId].id,
      };
    }
    return result;
  }, [selectedPropStateId]);

  const selectedPropPreset = useMemo(() => {
    return allPropPresets.find(
      (prop) => prop.id === selectedPropState?.instanceId
    );
  }, [selectedPropState]);

  const selectedProp = allProps.find(
    (prop) => prop.id === selectedPropPreset?.propId
  );

  const propDropdownItems = propsInTakeNotGrabbed.map((prop) => {
    return (
      <PiInteractionDropdown.Item
        key={prop.instanceId}
        onClick={() => onClick(prop.instanceId)}
      >
        <div className={"flex gap-4 justify-center w-full"}>
          <div className={"my-auto truncate"}>
            {allPropPresets.find((p) => p.id === prop.instanceId)?.name}
          </div>
        </div>
      </PiInteractionDropdown.Item>
    );
  });

  const propDropdown = (
    <PiInteractionDropdown label={label}>
      <PiInteractionDropdown.Trigger>
        <div className={"flex gap-x-4 w-full"}>
          <div className={"my-auto truncate"}>
            {selectedPropPreset?.name ?? "No Prop"}
          </div>
        </div>
      </PiInteractionDropdown.Trigger>
      {propDropdownItems}
    </PiInteractionDropdown>
  );

  return <>{propDropdown}</>;
}
